<template>
    <li class="px-2 py-1">
        <label :for="`${type}-${item.id}`" class="cursor-pointer" @change="updateFilter">
            <input type="checkbox" :id="`${type}-${item.id}`" :checked="isSelected" />
            {{ item.navn }} ({{ item.antall }})
        </label>
    </li>
</template>

<script>
export default {
    props: ['item','selected','type'],
    computed: {
        isSelected() {
            return this.selected.includes(this.item.id);
        }
    },
    methods: {
        updateFilter() {
            const data = {
                type: this.type,
                item: this.item
            };
            this.$emit('toggled', data);
        }
    },
};
</script>
